export default __webpack_public_path__ + "static/media/benefit5.091f4433.png";